export default {
    namespaced: true,
    state: {
        pagina:  'HARTFORD CONSULTAS',
        url:     'https://iberopa.com/_abk/exec.php',
        url_img: 'https://iberopa.com/_abk/lib/imagendb.php',
        url_tmp: 'https://iberopa.com/_abk/tmp/',
        url_tpv: 'https://iberopa.com/abks/adm.cemo/tpv_pago1.php',
        url_tpv1:'https://iberopa.com/_abk/adm/vc/tpv_pago1.php',

        abk_url: {
            user:   'abakan',
            salida: 'json',
            clase:  'adm/vc/especial',
            fnt:    '',
            args:   [],
        },

    },
    mutations: {
    },
    actions: {
    },
    getters: {
    }
}